export default {"src":"/_next/static/media/smiling-dog.9518567a.svg","height":20,"width":28,"blurWidth":0,"blurHeight":0};